import axios, { AxiosPromise, AxiosRequestConfig } from 'axios'

export class AnexoArquivos {
  salvarArquivo(formData: FormData, config: AxiosRequestConfig): AxiosPromise<string> {
    return axios.post(`/api/atendimento/anexarArquivo`, formData, config)
  }

  baixarArquivo(arquivoUuid: string): AxiosPromise<Blob> {
    return axios.get(`/api/atendimento/baixarArquivo`, {
      params: { uuid: arquivoUuid },
      responseType: 'blob',
    })
  }
}
